import { IconName, ScreenHeader } from '@fl/cmsch-fe-library';
import React, { FC, memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppModule } from 'api/gen/AppModule';
import { layoutAction, simpleLayoutSelector } from 'common/layout/model';

/** Props for the screen header wrapper that loads module tutorials on demand. */
interface Props {
  /** Header title displayed by the shared screen header. */
  title: string;
  /** Optional icon shown next to the title. */
  icon?: IconName;
  /** Module id used to fetch tutorials links for this screen. */
  moduleForTutorials?: AppModule;
}
const ConnectedScreenHeaderBase: FC<Props> = ({
  icon,
  title,
  moduleForTutorials
}) => {
  const dispatch = useDispatch();
  const tutorials = useSelector(simpleLayoutSelector.getTutorialsUrls).orUndef();
  useEffect(() => {
    if (moduleForTutorials) dispatch(layoutAction.getTutorials(moduleForTutorials));
    return () => {
      dispatch(layoutAction.getTutorialsSuccess(undefined));
    };
  }, [moduleForTutorials, dispatch]);
  return <ScreenHeader tutorials={tutorials} icon={icon} title={title} data-sentry-element="ScreenHeader" data-sentry-component="ConnectedScreenHeaderBase" data-sentry-source-file="index.tsx" />;
};

/**
 * Connects the shared screen header to tutorials state for the active module.
 *
 * @param props Screen header props and optional tutorials module binding.
 * @returns The shared screen header connected to layout tutorials state.
 *
 * @example
 * <ConnectedScreenHeader
 *     title="Dashboard"
 *     moduleForTutorials={AppModule.Home}
 * />
 */
export const ConnectedScreenHeader = memo(ConnectedScreenHeaderBase);